export default {
  // mask label 分页查询
  "selectMaskLabelListPage": "/backstageApi/background/mask/label/selectListPage",
  // 新增
  "addMaskLabel": "/backstageApi/background/mask/label/save",
  // update
  "updateMaskLabel": "/backstageApi/background/mask/label/update",
  // 删除
  "deleteByIdMaskLabel": "/backstageApi/background/mask/label/delete",
  // 根据id查询
  "selectOneMaskLabel": "/backstageApi/background/mask/label/selectOne",

  "selectListMaskLabel": "/backstageApi/background/mask/label/selectList",

  // mask facebook 分页查询
  "selectMaskFacebookListPage": "/backstageApi/background/mask/facebook/selectListPage",
  // 新增
  "addMaskFacebook": "/backstageApi/background/mask/facebook/save",
  // update
  "updateMaskFacebook": "/backstageApi/background/mask/facebook/update",
  // 批量更新
  "batchUpdateMaskFacebook": "/backstageApi/background/mask/facebook/batchUpdate",
  // 批量删除
  "batchDeleteMaskFacebook": "/backstageApi/background/mask/facebook/batchDelete",
  // 删除
  "deleteByIdMaskFaceBook": "/backstageApi/background/mask/facebook/delete",

}



// WEBPACK FOOTER //
// ./src/api/mask.js